import { CommonModule } from '@angular/common';
import { Component, ElementRef, inject, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FetchBillComponent } from './fetch-bill/fetch-bill.component';
import { ConfirmationModalConfig, ConfirmationModalService } from '@core/customCDK/cdkCustomMdl/services/confirmation-modal.service';
import { ToasterService } from '@core/services/toaster.service';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmationComponent } from '@core/customCDK/cdkCustomMdl/components/confirmation/confirmation.component';
import { BillPayServicesService } from './helper/bill-pay-services.service';


export enum MdlExitOptions {
  BTN_Confirm = 'btnConfirm',
  BTN_Close = 'btnClose',
  BTN_Cancel = 'btnCancel',
}
@Component({
  selector: 'app-bill-pay-services',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],

  templateUrl: './bill-pay-services.component.html',
  styleUrl: './bill-pay-services.component.scss',
})
export class BillPayServicesComponent {
  _BillPayservice: BillPayServicesService = inject(BillPayServicesService);
  _ConfirmationModalService: ConfirmationModalService = inject(
    ConfirmationModalService
  );
  @ViewChild('showInput') showInput: ElementRef<HTMLDivElement> | undefined;

  billerList: any;
  billerOpratorList: any = [];
  billerListAll: any;
  show: boolean = true;
  slectedValue: FormControl = new FormControl('');
  searchText: string = '';
  isActive: boolean = false;
  selectedIndex: number | null = null;
  selectedItem: any;
  constructor(private router: Router, private toaster: ToasterService) { }

  ngOnInit() {
    this.slectedValue.valueChanges.subscribe((v) => {
      // console.log(v , 'params..');
      if (v) {
        this._BillPayservice._BillerOpratorListData.next(v);

        // this._ConfirmationModalService.init(FetchBillComponent);
        this.router.navigate(['/bbps/fetch-bill'])

        this.slectedValue.setValue('', { emitEvent: false })
      }
      // else{
      //   const customConfig: ConfirmationModalConfig = {
      //     data: {
      //       icon: 'error',
      //       msg: 'File size exceeds the maximum limit 5MB',
      //       // btnConfirm: 'Okay',
      //       btnClose: 'Okay',
      //       showConfirmButton: false,
      //         allowOutsideClick: false,
      //         allowEscapeKey: false,
      //         showCancelButton: false
      //     },
      //   };
      //   this._ConfirmationModalService.init(ConfirmationComponent, customConfig).subscribe((events: any) => {
      //     events.initRef.close();
      //   });
      // }
    });
    this._BillPayservice.getBillerCategory().subscribe((res: any) => {
      if (res.response_code == '1') {
        // console.log(res.data, 'resafklsadjflka');
        this.billerListAll = res?.data;
        this.billerList = res?.data;
        // this.billerList = res?.data.slice(0, 6);
        // this.toaster.showSuccess(res?.message, 'Success');
      } else {
        const customConfig: ConfirmationModalConfig = {
          data: {
            icon: 'error',
            msg: res?.message,
            // btnConfirm: 'Okay',
            btnClose: 'Okay',
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            showCancelButton: false
          },
        };
        this._ConfirmationModalService.init(ConfirmationComponent, customConfig).subscribe((events: any) => {
          events.initRef.close();
        });
        // this.toaster.showError(res?.message, 'error');
      }
    });
  }

  selected(item: any, i: any) {
    this.selectedIndex = i;
    this.slectedValue.setValue('');

    const payLoad = {
      category_code: item.category_code,
    };
    this._BillPayservice.getBillerOpratorList(payLoad).subscribe((res: any) => {
      this.selectedItem = item;
      this.billerOpratorList = [];
      if (res?.response_code == '1' && res?.data.length > 0) {
        this.billerOpratorList = res?.data;

        this.show = false;
        // this.toaster.showSuccess(res?.message, 'Success');
        setTimeout(() => {
          if (this.showInput) {
            this.showInput.nativeElement.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }
        }, 10);
      }

      else {
        // this.toaster.showError(res?.message, 'error');
        const customConfig: ConfirmationModalConfig = {
          data: {
            icon: 'error',
            msg: res?.message,
            // btnConfirm: 'Okay',
            btnClose: 'Okay',
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            showCancelButton: false
          },
        };
        this._ConfirmationModalService.init(ConfirmationComponent, customConfig).subscribe((events: any) => {
          events.initRef.close();
        });
      }
    });
  }
  option(item: any) {
    // console.log(item);

    // console.log(this.slectedValue , 'sele...')
    const selectedBillerName = item?.target?.value;
    if (selectedBillerName) {
      let selectedBillerObject: any = {};
      if (selectedBillerName) {
        selectedBillerObject = this.billerOpratorList.find(
          (item: any) => item.biller_name === selectedBillerName
        );
        this._BillPayservice._BillerOpratorListData.next(selectedBillerObject);
        this._ConfirmationModalService.init(FetchBillComponent);
      }
    }
  }
  ShowAll() {
    this.show = false;
    this.billerList = this.billerListAll;
  }
  ShowAllLess() {
    this.show = true;
    this.billerList = this.billerListAll.slice(0, 6);
  }
}
